// @flow
import React from 'react';
import { notify, leaveBreadcrumb } from '../helpers/BugsnagClient';

import '../../static/scss/components/globalErrorBoundary.scss';

type Props = {
  children: any
};

type State = {
  hasError: boolean
};

class GlobalErrorBoundary extends React.Component<Props, State> {
  static getDerivedStateFromError() {
    leaveBreadcrumb('GlobalErrorBoundary shown');
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    notify(error, info);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="c-global-error-boundary">
        <h1>Something went wrong.</h1>
        <p>There has been a problem fulfilling your request</p>
        <p>
          Please{' '}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.location.reload();
            }}
          >
            reload
          </a>{' '}
          this page and try again or ask for{' '}
          <a href="https://help.justpark.com/hc/en-us">help</a> here
        </p>
      </div>
    );
  }
}

export default GlobalErrorBoundary;
